import ProceduresTableItem from './ProceduresTableItem';

export default ProceduresTableItem;
